import { Injectable, inject } from "@angular/core"
import { EnvService } from "./env.service"

@Injectable({
	providedIn: "root"
})
export class LoggerService {
	private envService = inject(EnvService)

	public log(
		type: "info" | "warn" | "error" | "auth" | "emitter" | "msal-routes" | "msal-logs" | "msal-events",
		...args: unknown[]
	) {
		const css = (color: string) =>
			`color: ${color}; font-weight: 900; text-transform: uppercase; padding: 2px 4px 1px; background: #0000005e; border: 1px solid currentColor; border-radius: 4px; line-height: 1.2`

		if (type === "msal-events" && this.envService.appConfig.logger.msalEvents) {
			console.log(`%c${type}`, css("#009a54"), ...args)
		}
		if (type === "msal-routes" && this.envService.appConfig.logger.msalRoutes) {
			console.log(`%c${type}`, css("#2a9a54"), ...args)
		}
		if (type === "msal-logs" && this.envService.appConfig.logger.msalLogs) {
			console.log(`%c${type}`, css("#2a919a"), ...args)
		}
		if (type === "auth" && this.envService.appConfig.logger.auth) {
			console.log(`%c${type}`, css("#8754e4"), ...args)
		}
		if (type === "emitter" && this.envService.appConfig.logger.emitter) {
			console.log(`%c${type}`, css("#a754e4"), ...args)
		}
		if (type === "info" && this.envService.appConfig.logger.info) {
			console.info(`%c${type}`, css("#3664ff"), ...args)
		}
		if (type === "error" && this.envService.appConfig.logger.error) {
			console.error(`%c${type}`, css("#be1b1b"), ...args)
		}
		if (type === "warn" && this.envService.appConfig.logger.warn) {
			console.warn(`%c${type}`, css("#dd860d"), ...args)
		}
	}
}
